<template>
  <div class="coin_introduction">
    <div class="title">
      <h2>{{ $t('概况') }}</h2>
      <div
        class="img_box"
        @click="
          isSignIn
            ? handleOriginCollect(
                currentCoinName,
                dealCoinCollect(currentCoinInfo.symbol)
              )
            : handleNativeCollect(currentCoinName)
        "
      >
        <img
          class="full_img"
          v-if="isSignIn"
          :src="
            dealCoinCollect(currentCoinInfo.symbol)
              ? collectionActive
              : collectionNegative
          "
          alt=""
        />
        <img
          class="full_img"
          v-else
          :src="
            $store.state.market.collectCoinListLocal[currentCoinName]
              ? collectionActive
              : collectionNegative
          "
          alt=""
        />
      </div>
    </div>
    <div class="content">
      <div class="coin_name">
        <div class="name">{{ currentCoinName }}</div>
        <div class="transaction" @click="jumpToName()">{{ $t('交易') }}</div>
      </div>
      <div class="kline_box">
        <div id="chartPreviewLine" style="width: 220px; height: 80px"></div>
        <div class="right_info">
          <p
            :class="{
              up_green: Number(currentCoinInfo.chg) > 0,
              down_red: Number(currentCoinInfo.chg) < 0
            }"
            class="current"
          >
            {{ currentCoinInfo.close | initFilter('--') }}
          </p>
          <p class="price_cny">
            ≈¥{{ currentCoinInfo.valuation | initFilter('--') }}
          </p>
          <p class="volume">
            24H {{ $t('量') }} {{ currentCoinInfo.volume | initFilter('--') }}
          </p>
          <p
            :class="{
              up_green: Number(currentCoinInfo.chg) > 0,
              down_red: Number(currentCoinInfo.chg) < 0
            }"
            class="up_down"
          >
            {{ Number(currentCoinInfo.chg) > 0 ? '+' : ''
            }}{{ currentCoinInfo.chg | initFilter('--') }}%
          </p>
        </div>
      </div>
      <div class="tab_box">
        <el-tabs v-model="activeTab">
          <el-tab-pane :label="$t('基本信息')" name="base">
            <div class="base_content">
              <div class="each_base">
                <p class="left">{{ $t('币种名称') }}</p>
                <p class="right">
                  {{ introductionData.baseCurrency | initFilter('- -') }}
                </p>
              </div>
              <div class="each_base">
                <p class="left">{{ $t('发行时间') }}</p>
                <p class="right">
                  {{ introductionData.issueTime | initFilter('- -') }}
                </p>
              </div>
              <div class="each_base">
                <p class="left">{{ $t('发行总量') }}</p>
                <p class="right">
                  {{ introductionData.issueAmount | initFilter('- -') }}
                </p>
              </div>
              <div class="each_base">
                <p class="left">{{ $t('流通总量') }}</p>
                <p class="right">
                  {{ introductionData.circulationAmount | initFilter('- -') }}
                </p>
              </div>
              <div class="each_base">
                <p class="left">{{ $t('众筹价格') }}</p>
                <p class="right">
                  {{ introductionData.crowdfunding | initFilter('- -') }}
                </p>
              </div>
              <div class="each_base">
                <p class="left">{{ $t('相关链接') }}</p>
                <p class="right">
                  <span
                    v-show="introductionData.officialWebsite"
                    class="is_link"
                    @click="jumpExternalLink(introductionData.officialWebsite)"
                    >{{ $t('官网') }}</span
                  >
                  <span
                    v-show="introductionData.whitePaper"
                    class="is_link"
                    @click="jumpExternalLink(introductionData.whitePaper)"
                    >{{ $t('白皮书') }}</span
                  >
                  <span
                    v-show="introductionData.blockQuery"
                    class="is_link"
                    @click="jumpExternalLink(introductionData.blockQuery)"
                    >{{ $t('区块查询') }}</span
                  >
                </p>
              </div>
              <div class="each_base">
                <p class="left">{{ $t('简介') }}</p>
              </div>
              <div class="introduction">
                {{ introductionData.introduction | initFilter('- -') }}
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import collect from '@/mixin/collect'
import { sendWSPush } from '@/utils/webSocket'
import { coinIntroduction } from '@/api/market'
import { mapState } from 'vuex'
export default {
  mixins: [collect],
  data() {
    return {
      collectionActive: require('./../../../assets/images/zixuan-xingxing-yixuan-blue.png'),
      collectionNegative: require('./../../../assets/images/zixuan-xingxing-weixuan.png'),
      activeTab: 'base',
      introductionData: {}, // 保存币种简介数据
      dateData: [], // 日期数组
      closeData: [], // 收盘价数组
      kLineParams: {
        action: 'kline',
        data: {
          symbol: this.$store.state.market.currentCoinName,
          from: this.$moment().valueOf() - 86400000,
          to: this.$moment().valueOf(),
          period: '1hour'
        }
      }
    }
  },
  computed: {
    ...mapState({
      currentCoinName: (state) => state.market.currentCoinName,
      currentCoinID: (state) => state.market.currentCoinID,
      currentCoinInfo: (state) => state.market.currentCoinInfo
    }),
    ...mapState(['klineData'])
  },
  watch: {
    currentCoinName(newVal, oldVal) {
      this.kLineParams.data.symbol = newVal
      sendWSPush(this.kLineParams)
      this.getCoinIntroduction()
    },
    klineData(newData, oldData) {
      const saveData = newData.data
      this.dateData = []
      this.closeData = []
      for (let i = 0; i < saveData.length; i++) {
        this.dateData.push(i)
        this.closeData.push(saveData[i].close)
      }
      this.getPreviewLine()
    }
  },
  created() {
    sendWSPush(this.kLineParams)
    this.getCoinIntroduction()
  },
  methods: {
    jumpToName() {
      const tradingPair = this.currentCoinName.replace(/\//, '_')
      this.$router.push({
        name: 'transaction',
        params: { tradingPair: tradingPair, coinId: this.currentCoinID }
      })
    },
    jumpExternalLink(link) {
      window.open(link)
    },
    getCoinIntroduction() {
      this.introductionData = {}
      coinIntroduction({ coinId: this.currentCoinID })
        .then((res) => {
          this.introductionData = res.data.data
        })
        .catch((err) => {
          this.introductionData = {}
          this.$Message.error({
            message: err.data.message
          })
        })
    },
    getPreviewLine() {
      const domObj = document.getElementById('chartPreviewLine')
      const previewLineChart = this.$echart.init(domObj)
      const option = {
        grid: {
          left: -1,
          right: 0,
          top: 0,
          bottom: 0
        },
        xAxis: {
          type: 'category',
          boundaryGap: false, // 两边不留白
          data: this.dateData
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          }
        },
        series: [
          {
            type: 'line',
            symbol: 'none',
            lineStyle: {
              color: 'rgba(57, 190, 239, 1)'
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(57, 190, 239, 0.1)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(216, 216, 216, 0.3)'
                  }
                ],
                global: false // 缺省为 false
              }
            },
            smooth: true,
            data: this.closeData
          }
        ]
      }
      previewLineChart.setOption(option, true)
    }
  }
}
</script>
<style lang="less" scoped>
.coin_introduction {
  height: 100%;
  width: 400px;
  background: rgba(255, 255, 255, 1);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  .title {
    padding: 20px 20px 18px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(232, 232, 232, 1);
    h2 {
      height: 22px;
      line-height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, 'PingFang SC';
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
    }
    .img_box {
      width: 12px;
      height: 12px;
      line-height: 11px;
      cursor: pointer;
    }
  }
  .content {
    .coin_name {
      padding: 20px 20px 40px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .name {
        height: 33px;
        font-size: 24px;
        font-family: PingFangSC-Semibold, 'PingFang SC';
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 33px;
      }
      .transaction {
        width: 120px;
        height: 40px;
        background: rgba(57, 190, 239, 1);
        border-radius: 4px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 40px;
        text-align: center;
        cursor: pointer;
      }
    }
    .kline_box {
      padding: 0 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .right_info {
        text-align: right;
        .current,
        .up_down {
          height: 28px;
          font-size: 20px;
          font-weight: 400;
          line-height: 28px;
          color: rgba(153, 153, 153, 1);
        }
        .price_cny,
        .volume {
          margin: 6px 0;
          height: 17px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 17px;
        }
        // 动态控制字体颜色
        .up_green {
          color: rgba(65, 179, 126, 1);
        }
        .down_red {
          color: rgba(206, 68, 68, 1);
        }
      }
    }
    .tab_box {
      margin-top: 26px;
      .base_content {
        .each_base {
          padding: 10px 30px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .left {
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
            line-height: 20px;
            flex: 0 0 auto;
          }
          .right {
            height: 20px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
            span {
              margin-left: 15px;
            }
          }
        }
        .introduction {
          height: 218px;
          padding: 10px 20px;
          overflow-y: auto;
        }
      }
    }
  }
}
</style>
